'use client';
import Editor from '@monaco-editor/react';
import CopyTextControl from '@/ui/CopyTextControl';
import { Tabs } from '@radix-ui/react-tabs';
// import * as Styled from './styled';

const THEME = 'chrome-devtools';

const editorOptions = {
  minimap: { enabled: false },
  scrollBeyondLastLine: false,
  fontSize: 12,
  lineNumbers: false,
  lineNumbersMinChars: 2,
  folding: false,
  fontFamily: 'Menlo, Monaco, "Courier New", monospace',
  padding: { top: 10, bottom: 10 },
};

type ScriptEditorProps = {
  language: string;
  content: string;
  originalContent?: string;
  onChange: (content: string) => void;
};

const ScriptEditor: React.FC<ScriptEditorProps> = ({ language, content, originalContent, onChange }) => {
  const numLines = content.split('\n').length || 1;
  const contentStyle = { backgroundColor: 'white', paddingLeft: 0, paddingRight: 0 };
  const isUnchanged = originalContent === content;
  return (
    <Editor
      // height={`${numLines + 2}lh`}
      height={220}
      defaultLanguage={language}
      language={language}
      theme={THEME}
      defaultValue={content}
      value={content}
      options={editorOptions}
      onChange={(value) => onChange(value as string)}
    />
  );
};

export default ScriptEditor;
